import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {selectToasts, hideToast} from 'ducks/notifications';

import closeIcon from 'assets/icons/close-button.svg';

import './styles.css';

const ToastRender = toast => (
  <React.Fragment>
    <div className="title">{toast.title}</div>
    <div className="content">{toast.text}</div>
  </React.Fragment>
);

interface ToasterProps {
  Component?: React.ComponentType;
}

class Toaster extends React.Component<
  ToasterProps & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>
> {
  state = {
    toastsFadingOutUuids: [],
    toastsFadingOutAnimations: {}
  };

  isFadingOut = uuid => {
    return this.state.toastsFadingOutUuids.filter(x => x == uuid).length >= 1;
  };

  startFadingOut = uuid => {
    if (!this.isFadingOut(uuid)) {
      this.setState({
        toastsFadingOutUuids: [...this.state.toastsFadingOutUuids, uuid],
        toastsFadingOutAnimations: {
          ...this.state.toastsFadingOutAnimations,
          [uuid]: setTimeout(() => this.removeElement(uuid), 5000)
        }
      });
    }
  };

  stopFadingOut = uuid => {
    clearTimeout(this.state.toastsFadingOutAnimations[uuid]);

    this.setState({
      toastsFadingOutUuids: this.state.toastsFadingOutUuids.filter(
        x => x != uuid
      )
    });
  };

  removeElement = uuid => {
    this.props.hideToast({uuid});
  };

  renderToast = toast => {
    const {Component} = this.props;
    if (Component) {
      return <Component {...toast} />;
    }
    return <ToastRender {...toast} />;
  };

  getColor = ({color}) => {
    switch (color) {
      case 'red':
        return 'Toast--red';
      case 'blue':
        return 'Toast--blue';
      case 'yellow':
        return 'Toast--yellow';
    }
    return {};
  };

  closeToast = uuid => {
    this.stopFadingOut(uuid);
    this.removeElement(uuid);
  };

  render() {
    const {toasts} = this.props;

    const visibleToasts = toasts.filter(toast => toast.isVisible);

    return (
      <div className="Toaster">
        {visibleToasts.map(toast => (
          <div
            key={toast.uuid}
            className={classNames(
              'Toast',
              {
                fadingOut: this.isFadingOut(toast.uuid)
              },
              this.getColor(toast)
            )}
            onMouseLeave={() => this.startFadingOut(toast.uuid)}
            onMouseEnter={() => this.stopFadingOut(toast.uuid)}>
            <div
              className="closeButton"
              onClick={() => this.closeToast(toast.uuid)}>
              <img src={closeIcon} alt="Close toast" />
            </div>
            {this.renderToast(toast)}
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {toasts: selectToasts(state)};
};

const mapDispatchToProps = {hideToast};

export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
